// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"7fe0c338","280":"fa8eb95a"}[chunkId] + ".chunk.css";
};